export default "__VITE_ASSET__BOz524RB__"